/**
 * Storage Helper - Abstracción para almacenamiento
 * 
 * NOTA: Token, user data, y role son manejados por el backend con cookies HttpOnly.
 * El frontend mantiene solo datos no-sensibles en localStorage.
 */

/**
 * Limpia la sesión (localStorage)
 * 
 * NOTA: Las cookies HttpOnly son manejadas automáticamente por el backend.
 * Esta función solo limpia localStorage para datos adicionales.
 */
export function clearSession() {
  // Las cookies HttpOnly son eliminadas automáticamente por el backend en logout
  localStorage.removeItem('hasConsentSalesForce');
  console.info('✓ Sesión limpiada (localStorage)');
}

// Export default para compatibilidad
export default {
  clearSession
};
